import endpoints from "../config/endpoints.json";
import connection_production from "../config/connection-production.json";
import connection_local from "../config/connection-local.json";
import connection_development from "../config/connection-development.json";
import axios from "axios";
import type { ApiResponse } from "../types";

const connection =
  process.env.REACT_APP_NODE_ENV === "local"
    ? connection_local
    : process.env.REACT_APP_NODE_ENV === "development"
    ? connection_development
    : process.env.REACT_APP_NODE_ENV === "production"
    ? connection_production
    : connection_local;

/**
 * Plan
 */
export const queryLearnerFrameworkAnnualPlanListByParams = async (
  queryParams
): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.plan.url}${endpoints.plans["framework-annual-plans"].context}${endpoints.plans["framework-annual-plans"].query.dto.context}`,
      queryParams
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};

export const queryLearnerFrameworkAnnualPlanByParams = async (queryParams): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.plan.url}${endpoints.plans["framework-annual-plans"].context}${endpoints.plans["framework-annual-plans"].query.dto["by-params"].context}`,
      queryParams
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};

export const queryLearnerFrameworkAnnualPlanWeekListByParams = async (
  queryParams
): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.plan.url}${endpoints.plans["framework-annual-plan-weeks"].context}${endpoints.plans["framework-annual-plan-weeks"].query.dto["by-params"].context}`,
      queryParams
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};

// The MEB master's weeks for a level + coterie — never the school's own plan (the "Okulda bu hafta" label).
export const queryPredefinedFrameworkAnnualPlanWeekListByLevelAndCoterie = async (queryParams): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.plan.url}${endpoints.plans["framework-annual-plan-weeks"].context}${endpoints.plans["framework-annual-plan-weeks"].query.dto.predefined["by-level-coterie"].context}`,
      queryParams
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};
